import React from 'react'
import IconShare from '../icons/IconShare'
import IconBack from '../icons/IconBack'

const TopHeaderMenu = (props) => {
  // ...
  return <div className={'header'}>
    { props.onClickBack && <button className={'header__back'}
      onClick={props.onClickBack}>
      <IconBack />
    </button>}
    <div className={'header__title'}>
      <div>{ props.competicion ? (`${props.competicion.nombre}`) : (<span>...</span>)}</div>
      <div className={'subtitle'}>{ props.evento ? (`${props.evento.nombre}`) : (<span>...</span>)}</div>
    </div>
    <button className={'header__share'}
      onClick={props.onClickShare}>
      <IconShare />
    </button>
  </div>
}

export default TopHeaderMenu



// WEBPACK FOOTER //
// ./src/components/TopHeaderMenu.js